import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../App";
import axios from "axios";
import { getHeaders, headers } from "../../http/axios";
import Auth from "../../auth/Auth";
import { toast } from "react-toastify";
import Spinner from "../Common/Spinner";
import { useAuth } from "../../auth/AuthProvider";

export default function Login() {
  const imageUrl = "./assets/images/";
  const navigate = useNavigate();
  const { token:authToken,setToken } = useAuth();

  // show hide password
  const [password, showPassword] = useState(false);
  const showpassword = () => showPassword(!password);
  // login api
  const { setSpinner } = useContext(GlobalContext);
  // -----use form login validation ----
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      email: "",
      password: "",
    },
  });
  // ----------------------- login api ------------------------
  const loginHandler = (data, e) => {
    e.preventDefault();
    setSpinner(true);
    try {
    //   if (!authToken) {
        axios
          .post(
            `${process.env.REACT_APP_API_KEY}client-login`,
            data,
            //  { headers: headers }
            { headers: getHeaders() } // Use getHeaders()
          )
          ?.then((res) => {
            if (res.status === 200) {
              const { userInfo, token } = res.data.data;

              setToken(token);
            //   document.cookie = `${Auth.tokenKey}=${token}`;

              Auth.login(userInfo, token);
              setSpinner(false);
              navigate("/category");
              toast.success(res.data.message);
            }
          })
          .catch((error) => {
            toast.error(error?.message);
            setSpinner(false);
          });
    
    } catch (error) {}
  };
  return (
    <>
      {/* {spinner && <Spinner />} */}
      <div className="login-form">
        <div className="text-center mb-8">
          <h1 className="heading-color Sora_SB text-3xl mb-2">Sign in</h1>
          <p className="Sora_R opacity-80  text-sm">
            Please enter your details
          </p>
        </div>
        <form onSubmit={handleSubmit(loginHandler)}>
          <div class="mb-8">
            <label class="block text-sm mb-2" for="username">
              Email
            </label>
            <div className="flex input-box">
              <input
                class="appearance-none  w-full focus:outline-none focus:shadow-outline"
                id="username"
                type="text"
                placeholder="Username"
                {...register("email", { required: true })}
              />
              <span>@</span>
            </div>
            {errors.email && (
              <span className="text-red-500 text-xs italic">
                This field is required
              </span>
            )}
          </div>
          <div class="mb-8">
            <label class="block text-sm mb-2" for="password">
              Password
            </label>
            <div className="flex input-box">
              <input
                class="appearance-none w-full focus:outline-none focus:shadow-outline"
                id="password"
                type={password ? "text" : "password"}
                placeholder="Enter password"
                {...register("password", { required: true })}
              />
              <img
                src={
                  password ? imageUrl + "eye-hide.svg" : imageUrl + "eye.svg"
                }
                alt=""
                onClick={showpassword}
                className="pointer"
              />
            </div>
            {errors.password && (
              <span className="text-red-500 text-xs italic">
                This field is required
              </span>
            )}
          </div>
          {/* <div className="w-full mb-8 text-right">
                    <Link class="inline-block align-baseline text-sm" to="/forgetPassword">
                        Forgot Password?
                    </Link>
                </div> */}
          <div class="flex items-center justify-between">
            <button class="btn w-full text-center">Sign In</button>
          </div>
        </form>
      </div>
    </>
  );
}
